import ShortUniqueId from "short-unique-id";

export const getRndShortId = (length = 10): string => {
  const uid = new ShortUniqueId({ length });
  return uid.rnd();
};
